const normalizeUrl = (url) =>
  typeof url === 'string' ? url.replace(/\/+$/, '') : '';

export const API_BASE_URL = normalizeUrl(process.env.REACT_APP_SERVER_URL || '');
export const API_DEFAULT_LANGUAGE = process.env.REACT_APP_DEFAULT_LANGUAGE;
export const API_PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY;
export const API_PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER;
export const API_DOMAIN = process.env.REACT_APP_DOMAIN;
